import React, {
    useState
} from 'react';

import {
    useDispatch,
    useSelector
} from 'react-redux';

import {
    Link
} from 'react-router-dom';


// Actions
import {
    resetPasswordAction
} from '../../actions/resetPasswordActions';

import {
    setearAlerta,
    ocultarAlertaAction
} from '../../actions/alertaActions';


// CSS
import {
    PaginaAuth,
    HeaderAuth,
    LogoLink,
    Logo,
    HeaderAcciones,
    LinkHeader,

    ContenidoAuth,
    PanelIlustracion,
    ImagenAuth,

    TarjetaAuth,
    EncabezadoAuth,
    TituloAuth,
    TextoAuth,

    EtiquetaGrupo,
    TipoGrid,
    TipoButton,

    FormularioAuth,
    CampoAuth,
    LabelAuth,
    InputAuth,

    CampoPassword,
    InputPassword,
    BotonOjo,
    IconoOjo,

    BotonPrincipalAuth,

    LinksAuth,
    LinkAuth,

    MensajeAuth,
    AyudaPassword
} from '../Css/StyledAuth';


const ResetPassword = () => {

    const dispatch =
        useDispatch();


    /*
    ========================================
    FORM
    ========================================
    */

    const [
        email,
        guardarEmail
    ] =
        useState('');


    const [
        password,
        guardarPassword
    ] =
        useState('');


    const [
        verificarPassword,
        guardarVerificarPassword
    ] =
        useState('');


    const [
        token,
        guardarToken
    ] =
        useState('');


    const [
        tipoUsuario,
        setTipoUsuario
    ] =
        useState(
            'Profesional'
        );


    const [
        verPassword,
        setVerPassword
    ] =
        useState(false);


    const [
        verConfirmacion,
        setVerConfirmacion
    ] =
        useState(false);


    /*
    ========================================
    REDUX
    ========================================
    */

    const cargando =
        useSelector(
            state =>
                state.estado.loading
        );


    const error =
        useSelector(
            state =>
                state.estado.error
        );


    const alerta =
        useSelector(
            state =>
                state.alertas.alerta
        );


    /*
    ========================================
    TIPO USUARIO
    ========================================
    */

    const cambiarTipoUsuario = (
        tipo
    ) => {

        dispatch(
            ocultarAlertaAction()
        );


        setTipoUsuario(
            tipo
        );

    };


    /*
    ========================================
    SUBMIT
    ========================================
    */

    const submitResetPassword = (
        e
    ) => {

        e.preventDefault();


        const emailLimpio =
            email
                .trim()
                .toLowerCase();


        const tokenLimpio =
            token.trim();


        if (
            !emailLimpio
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'Falta completar el email'
                })
            );


            return;

        }


        const emailValido =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                .test(
                    emailLimpio
                );


        if (
            !emailValido
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'Ingresá un email válido'
                })
            );


            return;

        }


        if (
            !tokenLimpio
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'Ingresá el código recibido por email'
                })
            );


            return;

        }


        if (
            !password ||
            !verificarPassword
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'Completá la nueva contraseña'
                })
            );


            return;

        }


        if (
            password !==
            verificarPassword
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'Las contraseñas deben coincidir'
                })
            );


            return;

        }


        if (
            password.length <
            8 ||
            password.length >
            15
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'La contraseña debe tener entre 8 y 15 caracteres'
                })
            );


            return;

        }


        if (
            !/[a-z]/.test(
                password
            )
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'La contraseña debe contener al menos una minúscula'
                })
            );


            return;

        }


        if (
            !/[A-Z]/.test(
                password
            )
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'La contraseña debe contener al menos una mayúscula'
                })
            );


            return;

        }


        if (
            !/[0-9]/.test(
                password
            )
        ) {

            dispatch(
                setearAlerta({
                    msg:
                        'La contraseña debe contener al menos un número'
                })
            );


            return;

        }


        dispatch(
            ocultarAlertaAction()
        );


        dispatch(
            resetPasswordAction({

                payload: {

                    email:
                        emailLimpio,

                    password,

                    token:
                        tokenLimpio,

                    tipoUsuario

                }

            })
        );

    };


    /*
    ========================================
    MENSAJES
    ========================================
    */

    const mensajeError =

        typeof error ===
        'string'

            ?
            error

            :
            error?.msg ||
            '';


    const nombreTipo =

        tipoUsuario ===
        'Paciente'

            ?
            'Entrenado'

            :
            tipoUsuario;


    return (

        <PaginaAuth>


            <HeaderAuth>


                <LogoLink
                    as={Link}
                    to="/"
                >

                    <Logo
                        src="/img/metodoYogenLogo_recortado.png"
                        alt="Método YÖGEN"
                    />

                </LogoLink>


                <HeaderAcciones>


                    <LinkHeader
                        as={Link}
                        to="/login"
                    >

                        Iniciar sesión

                    </LinkHeader>


                </HeaderAcciones>


            </HeaderAuth>


            <ContenidoAuth>


                <PanelIlustracion>


                    <ImagenAuth

                        src="/img/ilustracionResetPassword.png"

                        alt=""

                    />


                </PanelIlustracion>


                <TarjetaAuth>


                    <EncabezadoAuth>


                        <TituloAuth>

                            Creá una nueva contraseña

                        </TituloAuth>


                        <TextoAuth>

                            Ingresá el código que recibiste
                            por email y elegí una nueva
                            contraseña para tu cuenta de {
                                nombreTipo
                            }.

                        </TextoAuth>


                    </EncabezadoAuth>


                    <EtiquetaGrupo>
                        Tipo de cuenta
                    </EtiquetaGrupo>


                    <TipoGrid>


                        <TipoButton

                            type="button"

                            $activo={
                                tipoUsuario ===
                                'Profesional'
                            }

                            onClick={() =>
                                cambiarTipoUsuario(
                                    'Profesional'
                                )
                            }

                        >

                            Profesional

                        </TipoButton>


                        <TipoButton

                            type="button"

                            $activo={
                                tipoUsuario ===
                                'Paciente'
                            }

                            onClick={() =>
                                cambiarTipoUsuario(
                                    'Paciente'
                                )
                            }

                        >

                            Entrenado

                        </TipoButton>


                        <TipoButton

                            type="button"

                            $activo={
                                tipoUsuario ===
                                'Screening'
                            }

                            onClick={() =>
                                cambiarTipoUsuario(
                                    'Screening'
                                )
                            }

                        >

                            Screening

                        </TipoButton>


                    </TipoGrid>


                    <FormularioAuth
                        onSubmit={
                            submitResetPassword
                        }
                        noValidate
                    >


                        <CampoAuth>


                            <LabelAuth
                                htmlFor="email"
                            >

                                Email

                            </LabelAuth>


                            <InputAuth

                                type="email"

                                id="email"

                                name="email"

                                autoComplete="email"

                                value={
                                    email
                                }

                                disabled={
                                    cargando
                                }

                                onChange={
                                    e =>
                                        guardarEmail(
                                            e.target.value
                                        )
                                }

                            />


                        </CampoAuth>


                        <CampoAuth>


                            <LabelAuth
                                htmlFor="token"
                            >

                                Código recibido por email

                            </LabelAuth>


                            <InputAuth

                                type="text"

                                id="token"

                                name="token"

                                autoComplete="one-time-code"

                                placeholder="Código"

                                value={
                                    token
                                }

                                disabled={
                                    cargando
                                }

                                onChange={
                                    e =>
                                        guardarToken(
                                            e.target.value
                                        )
                                }

                            />


                        </CampoAuth>


                        <CampoAuth>


                            <LabelAuth
                                htmlFor="password"
                            >

                                Nueva contraseña

                            </LabelAuth>


                            <CampoPassword>


                                <InputPassword

                                    type={
                                        verPassword
                                            ?
                                            'text'
                                            :
                                            'password'
                                    }

                                    id="password"

                                    name="password"

                                    autoComplete="new-password"

                                    value={
                                        password
                                    }

                                    disabled={
                                        cargando
                                    }

                                    onChange={
                                        e =>
                                            guardarPassword(
                                                e.target.value
                                            )
                                    }

                                />


                                <BotonOjo

                                    type="button"

                                    onClick={() =>
                                        setVerPassword(
                                            valor =>
                                                !valor
                                        )
                                    }

                                >

                                    <IconoOjo

                                        src={
                                            verPassword
                                                ?
                                                '/img/ojo_invisible.png'
                                                :
                                                '/img/ojo_visible.png'
                                        }

                                        alt=""

                                    />

                                </BotonOjo>


                            </CampoPassword>


                        </CampoAuth>


                        <CampoAuth>


                            <LabelAuth
                                htmlFor="verificarPassword"
                            >

                                Repetir nueva contraseña

                            </LabelAuth>


                            <CampoPassword>


                                <InputPassword

                                    type={
                                        verConfirmacion
                                            ?
                                            'text'
                                            :
                                            'password'
                                    }

                                    id="verificarPassword"

                                    name="verificarPassword"

                                    autoComplete="new-password"

                                    value={
                                        verificarPassword
                                    }

                                    disabled={
                                        cargando
                                    }

                                    onChange={
                                        e =>
                                            guardarVerificarPassword(
                                                e.target.value
                                            )
                                    }

                                />


                                <BotonOjo

                                    type="button"

                                    onClick={() =>
                                        setVerConfirmacion(
                                            valor =>
                                                !valor
                                        )
                                    }

                                >

                                    <IconoOjo

                                        src={
                                            verConfirmacion
                                                ?
                                                '/img/ojo_invisible.png'
                                                :
                                                '/img/ojo_visible.png'
                                        }

                                        alt=""

                                    />

                                </BotonOjo>


                            </CampoPassword>


                        </CampoAuth>


                        <AyudaPassword>

                            La contraseña debe tener entre
                            8 y 15 caracteres, al menos una
                            mayúscula, una minúscula y un número.

                        </AyudaPassword>


                        <BotonPrincipalAuth

                            type="submit"

                            disabled={
                                cargando
                            }

                        >

                            {
                                cargando
                                    ?
                                    'Modificando contraseña...'
                                    :
                                    'Modificar contraseña'
                            }

                        </BotonPrincipalAuth>


                    </FormularioAuth>


                    <LinksAuth>


                        <LinkAuth
                            as={Link}
                            to="/restablecer-password"
                        >

                            Solicitar un código nuevo

                        </LinkAuth>


                    </LinksAuth>


                    {
                        mensajeError && (

                            <MensajeAuth $error>

                                {
                                    mensajeError
                                }

                            </MensajeAuth>

                        )
                    }


                    {
                        alerta?.msg && (

                            <MensajeAuth $error>

                                {
                                    alerta.msg
                                }

                            </MensajeAuth>

                        )
                    }


                </TarjetaAuth>


            </ContenidoAuth>


        </PaginaAuth>

    );

};


export default ResetPassword;